import { TemplateStore } from '@kurtosys/app-loader/dist/TemplateStore.js';
import { shared } from '@kurtosys/ksys-app-components';
import { IManifest } from '@kurtosys/types/appsManager/IManifest.js';

import { IBaseStores } from '../models/IBaseStores.js';
import { IComponentStylesBase } from '../models/IComponentStylesBase.js';
import { IConfigurationBase } from '../models/IConfigurationBase.js';

import { AppStoreBase } from './base/AppStoreBase.js';
import { StoreBase } from './base/StoreBase.js';
import { AccessibilityStore } from './AccessibilityStore.js';
import { EventBusStore } from './EventBusStore.js';
import { FetchAndQueryStore } from './FetchAndQueryStore.js';
import { InputStore } from './InputStore.js';
import { KurtosysApiStore } from './KurtosysApiStore.js';
import { QueryStore } from './QueryStore.js';
import { TranslationStore } from './TranslationStore.js';

export class StoreContext<
	TConfiguration extends IConfigurationBase,
	TComponentStyles extends IComponentStylesBase,
	TAppStore extends AppStoreBase<TConfiguration, TComponentStyles>,
	TApiStore extends KurtosysApiStore<TConfiguration, TComponentStyles>,
	TTemplateStore extends TemplateStore,
> {
	manifest: IManifest;
	private stores: IBaseStores<TConfiguration, TComponentStyles, TAppStore, TApiStore, TTemplateStore> = {};
	constructor(manifest: IManifest) {
		this.manifest = manifest;
	}
	set<TStore extends StoreBase<TConfiguration, TComponentStyles>>(storeKey: string, store: TStore) {
		this.stores[storeKey] = store;
		// this.registerStore(storeKey, store)
	}
	get<TStore extends StoreBase<TConfiguration, TComponentStyles> | shared.QueryStore>(
		storeKey: string,
	): TStore | undefined {
		if (this.stores[storeKey] !== undefined) {
			return this.stores[storeKey] as TStore;
		}
		// if (this.hasStoreRegistered(storeKey)) return this.getRegisteredStore(storeKey);
		return;
	}
	setup(
		appStore: TAppStore,
		apiStore: TApiStore,
		templateStore: TTemplateStore,
		otherStoresSetupFn: (storeContext: this) => void,
	) {
		this.stores.appStore = appStore;
		this.stores.kurtosysApiStore = apiStore;
		this.stores.templateStore = templateStore;
		this.stores.translationStore = new TranslationStore<TConfiguration, TComponentStyles>(this, this.manifest);
		this.stores.queryStore = new QueryStore<TConfiguration, TComponentStyles>(this, this.manifest);
		this.stores.fetchAndQueryStore = new FetchAndQueryStore<TConfiguration, TComponentStyles>(this, this.manifest);
		this.stores.accessibilityStore = new AccessibilityStore<TConfiguration, TComponentStyles>(this, this.manifest);
		this.stores.inputStore = new InputStore<TConfiguration, TComponentStyles>(this, this.manifest);
		this.stores.eventBusStore = new EventBusStore<TConfiguration, TComponentStyles>(this, this.manifest);
		otherStoresSetupFn(this);
		this.initialize();
	}
	initialize() {
		const appStore = this.get<TAppStore>('appStore');
		appStore.initialize();
	}
	reInitialize() {
		const appStore = this.get<TAppStore>('appStore');
		appStore.reInitialize();
	}
	get providerProps() {
		return this.stores;
	}
	// TODO: INVESTIGATE IF WE CAN REGISTER STORES AT WEB PAGE LEVEL (GLOBAL TO ALL APPS)
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	// registerStore(key: string, store: any) {}
	// hasStoreRegistered(key: string) {}
	// getRegisteredStore(key: string) {}
}
